import axios from 'axios';

const API = axios.create({
  baseURL: 'https://app.honeysucklepub.com/api/v1',
  headers: { 'Content-Type': 'application/json' },
  withCredentials: false,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default API;